export const SINGLE_CHAR_ERROR_MESSAGE = 'Needs to be at least 2 characters';
export const EMAIL_IS_NOT_VALID_MESSAGE = 'Please enter a valid email';
export const EMAIL_IS_REQUIRED_MESSAGE = 'Email is required';
export const USERNAME_MIN_LENGTH_MESSAGE = 'Needs to be at least 8 characters';
